export default "/kiban/_next/static/images/off-628e576948697fe8de5b05fb323ccb61.png";